import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../SearchListing/ListingItem/ListingItem.css';
import c from './HomeItem.css'
import {
  Row,
  Col,
  Button
} from 'react-bootstrap';
import cx from 'classnames';
import * as FontAwesome from 'react-icons/lib/fa';
import { injectIntl, FormattedMessage } from 'react-intl';

// Redux
import { connect } from 'react-redux';


// Component
import StarRating from '../../StarRating';
import CurrencyConverter from '../../CurrencyConverter';
import ListCoverPhoto from '../../ListCoverPhoto';
import ListItem from '../../ViewListing/ListingDetails/ListItem.js';
import WishListIcon from '../../WishListIcon';

// Locale
import messages from '../../../locale/messages';

// Helpers
import { formatURL } from '../../../helpers/formatURL';

//Images
import StartImage from '../../../../public/SiteImages/star.svg';
import SchreibtischImage from '../../../../public/SiteImages/schreibtisch.svg';

class HomeSlider extends React.Component {

  static propTypes = {
    formatMessage: PropTypes.func,
    id: PropTypes.number,
    photo: PropTypes.string.isRequired,
    beds: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    basePrice: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    roomType: PropTypes.string.isRequired,
    bookingType: PropTypes.string.isRequired,
    isSample: PropTypes.bool,
    listPhotos: PropTypes.array.isRequired,
    coverPhoto: PropTypes.number,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number,
    wishListStatus: PropTypes.bool,
    isListOwner: PropTypes.bool,
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.randomStyleClass = this.randomStyleClass.bind(this);
  }

  static defaultProps = {
    location: null,
  }

  randomStyleClass() {
    let styleClasses = {
      0: s.textDarkBlue,
      1: s.textLightBlue,
      3: s.textLightBrown,
      5: s.textBrown,
      6: s.textMaroon,
      7: s.textDarkBrown,
      8: s.textMediumBrown,
      9: s.textSkyBlue
    };

    let currentIndex = Math.floor(Math.random() * (9 - 0 + 1)) + 0;
    return styleClasses[currentIndex];
  }

  render() {
    const { id, photo, basePrice, currency, roomType, beds, title, bookingType, city, userAmenities, personCapacity, taxRate } = this.props;
    const { listPhotos, coverPhoto, reviewsCount, reviewsStarRating, userId } = this.props;
    const { wishListStatus, isListOwner, account } = this.props;
    const { formatMessage } = this.props.intl;
    const { isSample } = this.props;

    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount)
    }

    let currentUser = account && account.userId;

    let isWhisListIcon = false;
    if (userId == currentUser) {
      isWhisListIcon = true;
    }

    return (
      <div>
        <div className={cx(c.imgContainer)}>
          {
            isSample == true && <div className={cx(s.sampleListingContainer)}>sample</div>
          }
          {
            !isWhisListIcon && <WishListIcon listId={id} key={id} isChecked={wishListStatus} />
          }
          <div className={cx(c.parent)}>
            <div className={cx(c.children)}>
              <div className={cx(c.content)}>
                <a href={"/rooms/" + formatURL(title) + '-' + id}>
                  <ListCoverPhoto
                    className={cx(c.imageContent)}
                    coverPhoto={coverPhoto}
                    listPhotos={listPhotos}
                    photoType={"x_large"}
                    bgImage
                    lazyLoad
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={c.infoContainer}>
          <a className={s.linkContainer} href={"/rooms/" + formatURL(title) + '-' + id}>
            <Row className='homeSliderRtl'>
              <Col xs={12} sm={12} md={12} className={cx(s.space1, s.textEllipsis, s.infoDesc, s.infoText, s.infoSpace)}>
                <div className={cx(s.textEllipsis, s.listingInfo, s.displayInlineSection)}>
                  <span><img src={SchreibtischImage} className={s.workSpaceImage} /></span>
                  <span className='roomTypeRtl'>{personCapacity && personCapacity}{' '}{personCapacity > 1 ? formatMessage(messages.workSpaces) : formatMessage(messages.workSpace)}</span>
                  {/* <span>&nbsp;&#183;&nbsp;</span>
                  <span>{beds} { beds > 1 ? formatMessage(messages.beds) : formatMessage(messages.bed)}</span> */}
                </div>
                {/* <div className={cx(s.infoReview, s.infoSpaceTop1, s.startRight, s.displayInlineSection)}>
                  <div className={s.displayInlineSection}>
                    <span className={s.vtrTop}><img src={StartImage} /></span>
                    <span className={s.reviewCountText}>4.2</span>
                  </div>
                  <span className={cx(s.textInline, s.reviewText)}>
                    ({reviewsCount + ' '}{reviewsCount > 1 ? formatMessage(messages.reviews) : formatMessage(messages.review)})
                  </span>
                </div> */}
              </Col>
              <Col xs={12} sm={12} md={12} className={cx(s.textStrong, s.space1/* , s.textEllipsis */, s.infoTitle, s.infoText, 'listingInfoRTL')}>
                <p className={c.cityText}>{city}</p>
                <div className={cx(/* s.textEllipsis,  */s.listingTitle, 'textReversing', s.listTitleSection)}>
                  {title}
                </div>
                <div className={cx(s.textEllipsis, s.listingTitle, s.infoSpaceTop1, s.priceTextSection)}>
                  <CurrencyConverter
                    amount={basePrice}
                    from={currency}
                  />{' '}{ taxRate > 0 && <span className={s.plusVAT}>+ <FormattedMessage {...messages.VAT} /></span> }
                  {
                    //bookingType === "instant" && <span><FontAwesome.FaBolt className={s.instantIcon} /></span>
                  }
                  {' '}<span className={s.listingItem}>
                    <FormattedMessage {...messages.searchListingDayLabel} />
                  </span>
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} className={s.spaceTop1}>
                <div className={c.btnBorderBottom}>
                  {
                    userAmenities && userAmenities.length > 0 && <div><ListItem
                      itemList={userAmenities}
                      label={formatMessage(messages.thisSpaceOfferYou)}
                      showLabel={formatMessage(messages.showAmenities)}
                      hideLabel={formatMessage(messages.closeAmenities)}
                      icon={true}
                      pills={true}
                      bare={true}
                    /></div>
                  }
                </div>
              </Col>
            </Row>
          </a>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  account: state.account.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, c)(connect(mapState, mapDispatch)(HomeSlider)));


// WEBPACK FOOTER //
// src/components/Home/HomeItem/HomeItem.js